export class MapMarkerInfo {
    infoImage?: string;
    latitude?: number;
    longitude?: number;
    mapInfo?: string;
    mapLink?: string
    constructor(markerInfo?: MapMarkerInfo) {
        if(markerInfo) {
            if(markerInfo.longitude) this.longitude = markerInfo.longitude
            if(markerInfo.latitude) this.latitude = markerInfo.latitude
            if(markerInfo.infoImage) this.infoImage = markerInfo.infoImage
            if(markerInfo.mapInfo) this.mapInfo = markerInfo.mapInfo
            if(markerInfo.mapLink) this.mapLink = markerInfo.mapLink
        }
    }
}